import React, { lazy } from 'react';

const Home = lazy(() => import('.'));

const routes = [
  {
    path: '/',
    element: <Home />,
    title: 'Synthnode - Contact Exchange | Contact Management'
  },
  {
    path: '/cx',
    element: <Home />,
    title: 'Synthnode - Contact Exchange | Contact Management'
  }
];

export default routes;
